import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M9.54 4.09a.5.5 0 0 1 .92 0L12 7.734a.5.5 0 0 0 .266.266l3.644 1.54a.5.5 0 0 1 0 .92L12.266 12a.5.5 0 0 0-.266.266l-1.54 3.644a.5.5 0 0 1-.92 0L8 12.266A.5.5 0 0 0 7.734 12L4.09 10.46a.5.5 0 0 1 0-.92L7.734 8A.5.5 0 0 0 8 7.734z"
    }, null, -1)
  ]))]))
}
export default { render: render }